import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Default timeout of 30 seconds for normal requests.
    // Bulk PDF upload can take several minutes — use a 5-minute timeout for that endpoint.
    const isBulkUpload = request.url.includes('/uploadMultipleImage');
    const REQUEST_TIMEOUT = isBulkUpload ? 300000 : 30000;   // 5 min vs 30 s

    // Get token from localStorage
    const token = localStorage.getItem('token');
    
    // If token exists, add it to the request headers
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    // Pass the modified request to the next handler with timeout
    return next.handle(request).pipe(
      // Add timeout to all requests
      timeout(REQUEST_TIMEOUT),
      catchError((error: HttpErrorResponse | TimeoutError) => {
        // Handle timeout errors
        if (error instanceof TimeoutError) {
          console.error('Request timed out');
          return throwError(() => ({
            status: 408,
            error: {
              status: "error",
              msg: "Request timeout - operation took too long to complete",
              code: "REQUEST_TIMEOUT"
            }
          }));
        }
        
        // Handle authentication errors
        if (error.status === 401) {
          // Check for specific error codes from your backend
          const errorCode = error.error?.code;
          
          if (errorCode === 'TOKEN_EXPIRED' || 
              errorCode === 'INVALID_TOKEN' || 
              errorCode === 'NO_TOKEN' ||
              errorCode === 'UNAUTHORIZED' && token) {
            
            // Clear user data
            this.handleLogout();
          }
          else if(errorCode === 'UNAUTHORIZED' && !token){
            return throwError(() => ({
              status: 401,
              error: {
                status: "error",
                msg: error.error.msg,
                code: "UNAUTHORIZED"
              }
            }));
          }
        }

        if(error.status === 429){
          return throwError(() => ({
            status: 429,
            error: {
              status: "error",
              msg: error.error.msg,
              code: "TOO_MANY_REQUESTS"
            }
          }));
        }
        
        // Handle request timeout from server
        if (error.status === 408 || error.error?.code === 'REQUEST_TIMEOUT') {
          console.error('Server reported request timeout');
        }
        
        // Re-throw the error for other error handlers
        return throwError(() => error);
      })
    );
  }

  private handleLogout(): void {
    // Clear token and user session data from BOTH storages
    localStorage.removeItem('token');
    localStorage.removeItem('loginId');
    localStorage.removeItem('name');
    localStorage.removeItem('type');
    localStorage.removeItem('teamName');
    localStorage.removeItem('assignProcess');
    localStorage.removeItem('addedId');
    sessionStorage.removeItem('loginId');
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('type');
    sessionStorage.removeItem('teamName');
    sessionStorage.removeItem('assignProcess');
    sessionStorage.removeItem('addedId');
    this.router.navigate(['/user-pages/login']);
  }
}
